/**
 * Portal user types returned by auth APIs (`userTypeName` / `userType.name`).
 * Distinct from ROLE strings like INSTITUTE_USER.
 */
export const USER_TYPES = {
	INSTITUTE: "institute",
	FACULTY: "faculty",
	STUDENT: "student",
	ADMIN: "admin",
	EMPLOYER: "employer",
	ALUMNI: "alumni",
	ASSESSMENT_BODY: "assessment_body",
	COMMITTEE_MEMBER: "committee_member",
} as const;

export type UserType = (typeof USER_TYPES)[keyof typeof USER_TYPES];

/**
 * User role constants
 * @description Defines all possible user roles in the system
 */
export const USER_ROLES = {
	INSTITUTE_USER: "INSTITUTE_USER",
	ADMIN_USER: "ADMIN_USER",
	CM_USER: "CM_USER",
	FACULTY_USER: "FACULTY_USER",
} as const;

/**
 * Type for user roles
 */
export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

/**
 * Permission constants used for feature gating.
 * The system remains dynamic — new permissions from the API work without updating this list.
 */
export const PERMISSIONS = {
	ALL_READ: "all.read",
	MANAGE_SESSIONS_VIEW: "manage_sessions.view",
	MANAGE_SESSIONS_CREATE: "manage_sessions.create",
	MANAGE_SESSIONS_UPDATE: "manage_sessions.update",
	MANAGE_SESSIONS_DELETE: "manage_sessions.delete",
	MANAGE_SESSIONS_LIST: "manage_sessions.list",
} as const;

export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
